"use client";

import { PropsWithChildren, useState } from "react";
import IconArrowDown from "../icons/IconArrowDown";

export default function ReadMore({ children }: PropsWithChildren) {
  const [showReadMore, setShowReadMore] = useState(false);
  return (
    <>
      <div className={`read-more-wrapper ${showReadMore ? "open" : "closed"}`}>
        {children}
      </div>
      <div className="readMoreBtn-wrapper">
        <a
          href=""
          style={{ color: "var(--section--content-row_btn-color)" }}
          onClick={(e) => {
            setShowReadMore(!showReadMore);
            e.preventDefault();
          }}
        >
          <span>Lees meer</span>
          <IconArrowDown />
        </a>
      </div>
    </>
  );
}
